module.exports = __webpack_public_path__ + "assets/images/diabetes_y.f2e0920e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/diabetes_y.png
// module id = 700
// module chunks = 1